import { render } from "./record.vue?vue&type=template&id=d4b2b15c&scoped=true&ts=true"
import script from "./record.vue?vue&type=script&lang=tsx"
export * from "./record.vue?vue&type=script&lang=tsx"

import "./record.vue?vue&type=style&index=0&id=d4b2b15c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b2b15c"]])

export default __exports__